<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>assessment</mat-icon></div>
    <div class="am-header-text">
      <h2 class="cf-dlg-title">Tabla de amortización</h2>
      <p class="cf-dlg-subtitle" *ngIf="name || data.title">{{ name || data.title }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="closeDialog()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <ng-container *ngIf="!loading && !exporting; else busyTpl">
    <div class="cf-dlg-body">
      <ng-container *ngIf="rows.length; else emptyTpl">
        <div class="am-kpis">
          <div class="am-kpi">
            <span class="am-kpi__label">Total</span>
            <span class="am-kpi__value">{{ total | number:'1.2-2' }} €</span>
          </div>
          <div class="am-kpi">
            <span class="am-kpi__label">Amortizado</span>
            <span class="am-kpi__value">{{ accumulated | number:'1.2-2' }} €</span>
          </div>
          <div class="am-kpi am-kpi--highlight">
            <span class="am-kpi__label">Pendiente</span>
            <span class="am-kpi__value">{{ remaining | number:'1.2-2' }} €</span>
          </div>
        </div>

        <div class="am-table-wrap">
          <table mat-table [dataSource]="rows" class="am-table">
            <ng-container matColumnDef="year">
              <th mat-header-cell *matHeaderCellDef>Año</th>
              <td mat-cell *matCellDef="let r">{{ r.year }}</td>
            </ng-container>
            <ng-container matColumnDef="month">
              <th mat-header-cell *matHeaderCellDef>Mes</th>
              <td mat-cell *matCellDef="let r">{{ r.month }}</td>
            </ng-container>
            <ng-container matColumnDef="accountActivity">
              <th mat-header-cell *matHeaderCellDef>Cuenta</th>
              <td mat-cell *matCellDef="let r">{{ r.accountActivity || '—' }}</td>
            </ng-container>
            <ng-container matColumnDef="amount">
              <th mat-header-cell *matHeaderCellDef class="am-num">Importe</th>
              <td mat-cell *matCellDef="let r" class="am-num">{{ r.amount | number:'1.2-2' }} €</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: columns;"></tr>
          </table>
        </div>
      </ng-container>

      <ng-template #emptyTpl>
        <div class="am-empty">
          <mat-icon>info</mat-icon>
          <span *ngIf="loadError">No se pudo calcular la amortización. Inténtalo de nuevo más tarde.</span>
          <span *ngIf="!loadError">No hay amortización que mostrar. Para calcularla, la subvención de capital debe estar vinculada a una inversión.</span>
        </div>
      </ng-template>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" *ngIf="rows.length" (click)="export()">
        <mat-icon>file_download</mat-icon> Exportar Excel
      </button>
    </div>
  </ng-container>

  <ng-template #busyTpl>
    <app-loading-state [message]="exporting ? 'Generando Excel de amortización…' : 'Calculando amortización…'"></app-loading-state>
  </ng-template>
</div>
